// src/main.tsx — Vite SPA entry point
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import QueryProvider from "@/providers/QueryProvider";
import { Analytics } from "@/components/Analytics";
import { ToastContainer } from "@/components/ui/ToastContainer";
import { CookieConsent } from "@/components/CookieConsent";
import { AppRouter } from "@/router";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/app/globals.css";
import "@/app/hero.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <QueryProvider>
          <Analytics />
          <AppRouter />
          <CookieConsent />
          <ToastContainer />
        </QueryProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);

// Signal the prerenderer (scripts/prerender.ts) that React has mounted and
// Helmet has flushed meta tags into the DOM. Harmless on real clients.
if (typeof window !== "undefined") {
  const signal = () => {
    (window as unknown as { __PRERENDER_READY__?: boolean }).__PRERENDER_READY__ = true;
    document.dispatchEvent(new Event("prerender-ready"));
  };
  const ric = (window as unknown as { requestIdleCallback?: (cb: () => void) => void }).requestIdleCallback;
  if (typeof ric === "function") {
    ric(signal);
  } else {
    setTimeout(signal, 0);
  }
}
